import StatementsAndFormsScreen from 'features/statementsAndForms/screens/StatementsAndForms/StatementsAndFormsScreen';
import React from 'react';

export default function StatementsAndFormsScreenPage() {
  return <StatementsAndFormsScreen />;
}
